import { render } from "./BsIcon.vue?vue&type=template&id=133897da"
import script from "./BsIcon.vue?vue&type=script&lang=js"
export * from "./BsIcon.vue?vue&type=script&lang=js"
script.render = render

export default script